<template>
  <v-container fluid>
    <v-row>
      <v-col cols='12' lg='10' offset-lg='1'>
        <h2 class='title mb-3'>記事グループ一覧</h2>

        <permission-guard :situation='situations.postListManagement'>
          <v-simple-table fixed-header>
            <template v-slot:default>
              <thead>
              <tr>
                <th class='text-center'>名前</th>
                <th />
              </tr>
              </thead>
              <tbody>
              <tr v-for='(groupRole) in groupRoles' :key='groupRole.value'>
                <td class='text-center'>
                  {{ groupRole.text }}
                </td>
                <td class='text-center'>
                  <router-link
                    :to='editLink(groupRole.value)'
                  >
                    <v-btn tile outlined small color='primary'>
                      <v-icon left small> mdi-pencil</v-icon>
                      編集
                    </v-btn>
                  </router-link>
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </permission-guard>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import draggable from 'vuedraggable'
import PostGallary from '@/components/commons/PostGallary'
import headUtilsMixin from '@/mixins/head_utils'
import SituationUtils from '@/mixins/situation_utils'
import PermissionGuard from '@/components/commons/PermissionGuard'
import { adminPostGroupEdit } from '@/src/routers/admin'
import formValidationUtils from '@/mixins/form_validation_utils'

export default {
  name: 'PostLists',
  components: {
    PostGallary,
    draggable,
    PermissionGuard
  },
  mixins: [headUtilsMixin, SituationUtils, formValidationUtils],
  data: () => {
    return {
      pageTitle: '記事グループ一覧',
      groupRoles: [
        { text: 'ピックアップ', value: 'pick_up' },
        { text: 'ランキング', value: 'ranking' },
        { text: '新着記事', value: 'arrival' },
        { text: 'スライダー', value: 'slider' }
      ]
    }
  },
  methods: {
    editLink (groupRole) {
      return {
        name: adminPostGroupEdit,
        params: { group_role: groupRole }
      }
    }
  }
}
</script>

<style scoped>
th,
td {
  vertical-align: middle;
}
</style>
